import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none"
}
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<g clip-path=\"url(#a)\"><path fill=\"#D80027\" d=\"M0 12C0 5.373 5.373 0 12 0s12 5.373 12 12c-.522 0-12 1.565-12 1.565z\"></path><path fill=\"#000\" d=\"M24 12c0 6.628-5.373 12-12 12S0 18.628 0 12\"></path><path fill=\"#FFDA44\" d=\"m10.352 9.544 1.017.738-.388 1.196 1.017-.74 1.017.738-.39-1.195 1.017-.74-1.257.001-.389-1.195-.388 1.196z\"></path><path fill=\"#FFDA44\" d=\"M14.998 6.803a5.96 5.96 0 0 0-3-.802v1.565a4.4 4.4 0 0 1 2.218.593 4.44 4.44 0 0 1 1.623 6.058 4.44 4.44 0 0 1-6.058 1.623 4.4 4.4 0 0 1-1.482-1.398l-1.307.863a5.96 5.96 0 0 0 2.006 1.89A6.007 6.007 0 0 0 17.195 15a6.007 6.007 0 0 0-2.197-8.196\"></path><path fill=\"#FFDA44\" d=\"M8.54 10.956a1.565 1.565 0 0 0 .622 2.124l5.083 2.778c-.345.632-.162 1.401.47 1.747l1.374.751a1.304 1.304 0 0 0 1.77-.518l.751-1.373z\"></path></g><defs><clipPath id=\"a\"><path fill=\"#fff\" d=\"M0 0h24v24H0z\"></path></clipPath></defs>", 2)
const _hoisted_4 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_4]))
}
export default { render: render }